import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { routingState } from '@adornis/router/client/routing-state.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import './actions/bh-page-action-login.js';

@customElement('bh-page-action')
export class BHPageAction extends BuchungsheldLitElement {
  @state() private readonly _mode = new RXController(this, routingState.searchParams.get('mode'));

  override render() {
    switch (this._mode.value) {
      case 'login':
        return html` <bh-page-action-login></bh-page-action-login> `;
      default:
        return html` unknown flow `;
    }
  }

  override styles() {
    return [
      ...super.styles(),
      { ':host': { display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' } },
    ];
  }
}
